module.exports = __webpack_public_path__ + "static/media/a-1.0c80630d.jpg";